import { ContentSection, Heading } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MyProfile } from '../../components/my-profile';

export const MyProfilePage: React.FC = () => {
    const { t: cms } = useTranslation('profile-cms');
    const title = cms('headline');

    return (
        <ContentSection pageWrapSize="medium">
            <Heading level={1}>{title}</Heading>
            <h2>{cms('description')}</h2>
            <MyProfile />
        </ContentSection>
    );
};
